<template>
  <div>
    <div class="row" v-show="error">
      <div class="col bg-danger alert status-box" >
        {{error}}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Who is purchasing the commissions of {{userName}}?</label>
      </div>
      <div class="col-6">
        <dropdown
          :list="channelNames"
          :value="channel.name"
          @input="setChannel"
        >
        </dropdown>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <label>Schedule Payments</label>
      </div>
    </div>


    <div class="row table-head">

      <div class="col">
        Payment Date
      </div>
      <div class="col">
        Payment Amount
      </div>
    </div>

    <div class="row" v-for="p, i in payments">

      <div class="col">
        <div class="input-group date-picker-form-control">
            <datepicker v-model="payments[i].date" name="" input-class="form-control" format="MM/dd/yy" ></datepicker>
            <i class=" input-group-addon fa fa-calendar"></i>
        </div>
      </div>
      <div class="col">
        <div class="input-group">
          <i class=" input-group-addon fa fa-dollar"></i>
          <input type="text" v-model="p.amount" name="" class="form-control" @blur="formatRow(i, p)" @input.lazy="addRow(i)" />
        </div>
      </div>


    </div>


    <div class="modal-footer">
      <button class="btn btn-clear" @click="$emit('close');" >Cancel</button>
      <button @click="save" class="btn btn-primary">Buy Commissions</button>
    </div>
  </div>

</template>
<script type="text/babel">
  import Datepicker from 'vuejs-datepicker';
  import Autocomplete from '../assets/Autocomplete.vue';
  import Dropdown from '../assets/Dropdown.vue';

  export default {
    name: 'BuyCommissions',
    data: function(){
      return {
        channel:{
          channel_id: '',
          name: ''
        },
        channels:[],
        payments:[
          {
            date: null,
            amount: ''
          }
        ],
        error:null
      }
    },
    components:{
      Datepicker,
      Autocomplete,
      Dropdown
    },
    computed:{
      channelNames(){
        return this.channels.map(function(u){
          return u.name;
        })
      }
    },
    created(){
      this.fetchChannels();
    },
    filters:{

    },
    methods:{
      addRow(i){
        if(i == this.payments.length -1){
          this.payments.push({
            date: null,
            amount: ''
          });

        }
      },
      formatRow(i, p){
        if(isNaN(this.payments[i].amount) || !this.payments[i].amount){
          this.payments[i].amount = null;
        }


        if(!p.amount && this.payments.length > 1 && i != this.payments.length - 1 ){
          this.payments.splice(i, 1);
        } else {
          this.payments[i].amount = (Math.round(this.payments[i].amount * 100) / 100).toFixed(2);
        }
      },
      fetchChannels(search){
        var _this = this;
        this.channel.name = search;

        this.$send(this, 'channels').then(r => {
          this.channels = r.channels;
        });


//
//        this.$http.post('http://10.0.24.14/api.php', {
//          function: 'channels',
//          data: {}
//        }, {
//          emulateJSON: true
//        }).then(function(response){
//          if(response.body.status){
//            _this.channels = response.body.data.channels;
//            console.log(_this.channels);
//          }
//        });
      },
      setChannel(selection){
        this.channel = this.channels.filter(function(c){
          return c.name == selection;
        })[0];

        this.channel = this.channel || {};


      },
      save(){

        var _this = this;

        this.error = null;

        var payments = this.payments.filter(function(p){
          return p.amount && p.date;
        }).map(function(p){
          return {
            amount: p.amount,
            date: moment(p.date).format('YYYY-MM-DD')
          }
        });

        if(!this.channel.channel_id){
          this.error = "Please enter a valid channel";
          return;
        }

        if(!payments.length){
          this.error = "Please enter a payment";
          return;
        }

        if(!this.agent.accountUser_id){
          this.error = "An error occurred. Please close this window and try again.";
          return;
        }

        if(this.error) return false;

        this.$send(this, 'accountPurchase',{
          channel_id: this.channel.channel_id,
          accountUser_id: this.agent.accountUser_id,
          payments: payments
        }).then(r => {
          this.$emit('refetch');
          this.$emit('close');
        });

      }
    },

    props: ['agent', 'userName']
  }


</script>
<style>
  .row.table-head{
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// BuyCommissions.vue?0d74dd87